import { useContext } from 'react';
import { Paper, Typography, FormControl, InputLabel, Select, MenuItem } from '@material-ui/core';
import { TablesContext } from '../TablesContext';
import { makeStyles } from '@material-ui/core/styles';
import { DbType, LocalTableNames } from '../../../../../helpers/Common';

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(2)
    },
    selector: {
        width: '100%'
    },
    notables: {
        padding: "16px"
    }
}));

export const TableSelector = (props) => {
    const classes = useStyles();

    const {
        state,
        setSelectedTableId,
        isLoadingTableValues
    } = useContext(TablesContext);

    const {
        tables
    } = state;

    const getTables = () => {
        const allTables = tables
            .filter(x =>
                x.valueType === props.tableValueType &&
                (props.dbType === DbType.S4 ? x.name !== LocalTableNames.PrincipalOperationCountries : true)
            );

        if (props.dbType === DbType.ECC) {
            allTables.forEach(table => {
                if (table.name === LocalTableNames.PrincipalOperationCountries)
                    table.name = "Principal Operating Countries";
            });
        }

        // Applica il criterio di ordinamento solo ai "Customer Groups"
        const sortedTables = allTables.sort((a, b) => {
            if (a.name.startsWith("Customer Groups") && b.name.startsWith("Customer Groups")) {
                const numA = parseInt(a.name.match(/\d+$/)?.[0] || "0", 10);
                const numB = parseInt(b.name.match(/\d+$/)?.[0] || "0", 10);
                return numA - numB;
            }

            return 0; // Mantiene l'ordine originale per le altre voci
        });

        return sortedTables;
    };


    const itemSelectHandler = (e) => {
        const tableId = e.target.value;
        setSelectedTableId(tableId);
    }

    return (
        <>
            {
                getTables().length > 0 ?

                    <Paper className={classes.root}>
                        <FormControl className={classes.selector}>
                            <InputLabel>
                                All tables
                            </InputLabel>
                            <Select
                                value={state.selectedTableId}
                                onChange={itemSelectHandler}
                                disabled={isLoadingTableValues}
                            >
                                {
                                    getTables() &&
                                    getTables().map((table, index: number): JSX.Element =>
                                        <MenuItem
                                            key={index}
                                            value={table.tableDefinitionId}
                                        >
                                            {table.name}
                                        </MenuItem>
                                    )
                                }
                            </Select>
                        </FormControl>
                    </Paper> :

                    <Paper className={classes.notables}>
                        <Typography variant="h6">
                            No tables available.
                        </Typography>
                        <Typography variant="body1">
                            There's no tables avaiable at this time.
                        </Typography>
                    </Paper>
            }
        </>
    );
};